import { useEffect, useState } from "react";

export const CaptainLogo = ({ size = 40 }: { size?: number }) => {
  const [glowIntensity, setGlowIntensity] = useState(0.5);

  useEffect(() => {
    const interval = setInterval(() => {
      setGlowIntensity(Math.random() * 0.5 + 0.3);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative">
      <div 
        className="relative rounded-lg overflow-hidden"
        style={{ 
          width: size, 
          height: size,
          boxShadow: `0 0 ${20 * glowIntensity}px hsl(var(--cyber-blue) / ${glowIntensity})`
        }}
      >
        {/* T.R.AI TOMMYROCA.AI Logo - Captain's Wheel with Neural Network Brain */}
        <img 
          src="/captain-roca-logo.png"
          alt="Captain ROCA — AI Maritime Companion"
          className="w-full h-full object-contain"
        />
        
        {/* Subtle glow overlay */}
        <div 
          className="absolute inset-0 rounded-lg animate-pulse pointer-events-none"
          style={{
            background: `linear-gradient(45deg, transparent, hsl(var(--cyber-blue) / 0.1), transparent)`
          }}
        />
      </div>
    </div>
  );
};